import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=7580ef76&scoped=true&functional=true"
var script = {}
import style0 from "./Player.vue?vue&type=style&index=0&id=7580ef76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7580ef76",
  null
  
)

export default component.exports